

































import { computed, defineComponent, useStore } from '@nuxtjs/composition-api'
import { useNamespacedStore } from '~/compositions/store'
import {
  QUICK_SEARCH_NS,
  QuickSearchState
} from '~/store/modules/shared/quickSearch/state'
import { USER_AGENT_NS } from '~/store/modules/shared/userAgent/state'

export default defineComponent({
  setup() {
    const { state } = useNamespacedStore<QuickSearchState>(QUICK_SEARCH_NS)

    const configTitle = computed(() => state.config.title)
    const configLogo = computed(() => state.config.logo)
    const randomBackgroundImageUrl = computed(
      () => state.randomBackgroundImageUrl
    )

    const titleClasses = computed(() => {
      if (!configLogo.value) {
        return ['md:tw-mb-12 tw-mb-4']
      }
      return []
    })

    const style = computed(() => {
      return {
        backgroundImage: `url(${randomBackgroundImageUrl.value})`
      }
    })

    const store = useStore()
    const isPc = computed(() => store.getters[`${USER_AGENT_NS}/isPc`])

    return {
      configTitle,
      configLogo,
      style,
      titleClasses,
      isPc
    }
  }
})
